<!-- 缺货登记数据操作 -->
<template>
   <div>
      <el-dialog title="新增取消订单" :visible.sync="dataActionBox.showStatus" width="70%">
         <div class="demo-drawer__content data_action_form">
            <div class="table_content_box">
               <!-- 主要信息 -->
               <div>
                  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                     <el-tab-pane label="整单" name="first">
                        <el-button style="margin-top: 10px;" type="primary" size="mini"
                           @click="openSearch(20873997159610)">整单提取</el-button>
                        <el-form id="mainInfo" :model="sendDataInfo" ref="sendDataInfo" class="baseForm" size="mini"
                           label-position="right" label-width="120px" :show-message="false" :inline-message="false">
                           <el-row>
                              <el-form-item label="单号" prop="jobid"
                                 :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('单号')" v-html="'单号'"></label>
                                 <el-input v-model="sendDataInfo.jobid" readonly placeholder="提取单据">
                                 </el-input>
                              </el-form-item>
                              <el-form-item label="明细单号">
                                 <label slot="label" :style="$common.labelStyle('明细单号')" v-html="'明细单号'"></label>
                                 <el-input v-model="sendDataInfo.jobdtlid" readonly>
                                 </el-input>
                              </el-form-item>
                              <el-form-item label="业务类型">
                                 <label slot="label" :style="$common.labelStyle('业务类型')" v-html="'业务类型'"></label>
                                 <el-input v-model="sendDataInfo.operationtype" readonly>
                                 </el-input>
                              </el-form-item>
                              <el-form-item label="出入库标识">
                                 <label slot="label" :style="$common.labelStyle('出入库标识')" v-html="'出入库标识'"></label>
                                 <el-radio-group v-model="sendDataInfo.jobflag" disabled size="mini">
                                    <el-radio-button :label="0">入库业务</el-radio-button>
                                    <el-radio-button :label="1">出库业务</el-radio-button>
                                 </el-radio-group>
                              </el-form-item>
                              <el-form-item label="取消原因" prop="memo">
                                 <label slot="label" :style="$common.labelStyle('取消原因')" v-html="'取消原因'"></label>
                                 <el-input v-model="sendDataInfo.memo" type="textarea" clearable></el-input>
                              </el-form-item>
                           </el-row>
                        </el-form>
                     </el-tab-pane>
                     <el-tab-pane label="明细" name="second">
                        <el-button style="margin-top: 10px;" type="primary" size="mini"
                           @click="openSearch(20873997159611)">明细提取</el-button>
                        <el-button style="margin-top: 10px;" type="danger" size="mini"
                           @click="detailsDel">删除</el-button>
                        <el-table :data="sendDataList" style="width: 100%" size="mini" height="300" border>
                           <el-table-column label="选择操作" width="80">
                              <template slot-scope="scope">
                                 <el-radio v-model="selectIndex" :label="scope.$index" border size="mini">
                                    <i class="el-icon-thumb"></i>
                                 </el-radio>
                              </template>
                           </el-table-column>
                           <el-table-column prop="jobid" label="单号" min-width="180"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="jobdtlid" label="明细单号" min-width="180"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="operationtype" label="业务类型" min-width="100"
                              show-overflow-tooltip></el-table-column>
                               <el-table-column prop="bgmName" label="通用名称" min-width="100"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="bgmCode" label="商品编号" min-width="130"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="bgpUnitmeasurement" label="包装单位" min-width="100"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="jobflag" label="出入库标识" min-width="100" show-overflow-tooltip>
                              <template slot-scope="scope">
                                 <span v-if="scope.row.jobflag === 0">入库业务</span>
                                 <span v-else-if="scope.row.jobflag === 1">出库业务</span>
                              </template>
                           </el-table-column>
                            <el-table-column prop="businessNum" label="订单数量" min-width="130"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="manufacturer" label="生产厂商" min-width="130"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="placeorigin" label="产地" min-width="130"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="batchno" label="批号" min-width="130"
                              show-overflow-tooltip></el-table-column>
                           <el-table-column prop="prodate" label="生产日期" min-width="130">
                              <template slot-scope="scope">
                                 <span class="ellipsis-cell">{{ $common.getLocalTime(scope.row.prodate) }}</span>
                              </template>
                           </el-table-column>
                           <el-table-column prop="expidate" label="失效日期" min-width="130">
                              <template slot-scope="scope">
                                 <span class="ellipsis-cell">{{ $common.getLocalTime(scope.row.expidate) }}</span>
                              </template>
                           </el-table-column>
                           <el-table-column prop="memo" label="取消原因" min-width="200">
                              <template slot-scope="scope">
                                 <el-input v-model="scope.row.memo" type="text" clearable></el-input>
                              </template>
                           </el-table-column>
                        </el-table>
                     </el-tab-pane>
                  </el-tabs>
               </div>
            </div>
            <div class="foots">
               <el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                  v-if="dataActionBox.actionType == 0">保存</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                  v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>
         </div>
         <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple v-if="activeName == 'second'" ref="SearchSchemeMultiple" :id="seId"
               :parentData="parentData" :parentSearchData="parentSearchData" @getWidth="getSeWidth"
               @sendTitle="getSearchName" />
            <SearchScheme v-else ref="searchScheme" :id="seId" :smId="opmId" :parentSearchData="parentSearchData"
               @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span v-if="activeName == 'second'" slot="footer" class="dialog-footer">
               <el-button @click="DialogVisible = false">取 消</el-button>
               <el-button type="primary" @click="changeInputModel">确认选择</el-button>
            </span>
         </el-dialog>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue"
import SearchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue"
export default {
   name: 'gyxnCancelOrderAction',
   props: [],
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme, SearchSchemeMultiple },
   data() {
      //这里存放数据
      return {
         activeName: 'first',
         dataActionBox: {
            showStatus: false,
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            "credate": "",
            "goodsownerid": "",
            "gyxnState": 0,
            "id": 0,
            "jobdtlid": "",
            "jobflag": 0,
            "jobid": "",
            "memo": "",
            "msg": "",
            "operationtype": "",
            "username": ""
         },
         sendDataList: [],
         selectData: [],
         selectIndex: 0,
         parentData: {
            type: "",
            list: []
         },
         seTitle: "",//检索
         DialogVisible: false,
         seWidth: '0',
         seId: 0,
         opmId: 0,
         parentSearchData: {},
         setField: "",

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      handleClick() {
         if (this.activeName == 'first') {
            this.sendDataList = []
            this.selectData = []
         } else {
            this.sendDataInfo = {
               "credate": "",
               "goodsownerid": "",
               "gyxnState": 0,
               "id": 0,
               "jobdtlid": "",
               "jobflag": 0,
               "jobid": "",
               "memo": "",
               "msg": "",
               "operationtype": "",
               "username": "",
               "bgmName": "",
               "bgpUnitmeasurement": "",
               "prodate": "",
               "expidate": "",
               "bgmCode": "",
               "businessNum": "",
               "manufacturer": "",
               "placeorigin": "",
               "batchno": "",
               

            }
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId) {
         if (sId == 20873997159611) {
            this.parentData.type = 'jobdtlid'
            this.parentData.list = this.selectData
         }
         this.DialogVisible = true
         this.seId = sId
      },
      detailsDel() {
         if (this.sendDataList.length == 0) {
            return this.$message.error("暂无需要删除的数据")
         }
         this.sendDataList.splice(this.selectIndex, 1)
      },
      //检索带回数据
      changeInputModel(val) {

         if (this.seId == 20873997159610) {//整单
            if (!val || val == undefined) {
               return this.$message({
                  message: '未返回数据',
                  type: 'error'
               })
            }
            for (const key in this.sendDataInfo) {
               if (val[key] != undefined && val[key] !== "" && val[key] != null) {
                  this.sendDataInfo[key] = val[key]
               }
            }
         } else if (this.seId == 20873997159611) {//明细
            var mx = this.$refs.SearchSchemeMultiple.multipleSelection
            if (this.sendDataList.length == 0) {
               this.sendDataList = []
               mx.forEach(item => {
                  this.sendDataList.push({})
                  this.selectIndex = this.sendDataList.length - 1
                  for (const key in this.sendDataInfo) {
                     if (item[key] != undefined && item[key] !== "" && item[key] != null) {
                        this.$set(this.sendDataList[this.selectIndex], key, item[key])
                     } else {
                        this.$set(this.sendDataList[this.selectIndex], key, this.sendDataInfo[key])
                     }
                  }
               })
               this.selectData = mx
            } else {
               this.sendDataList.forEach(item => {
                  mx.forEach((item1, index1) => {
                     if (item1.jobdtlid == item.jobdtlid) {
                        mx.splice(index1, 1)
                     }
                  })
               })
               if (mx.length > 0) {
                  this.selectData = mx
                  mx.forEach(item => {
                     this.sendDataList.push({})
                     this.selectIndex = this.sendDataList.length - 1
                     for (const key in this.sendDataInfo) {
                        if (item[key] != undefined && item[key] !== "" && item[key] != null) {
                           this.$set(this.sendDataList[this.selectIndex], key, item[key])
                        } else {
                           this.$set(this.sendDataList[this.selectIndex], key, this.sendDataInfo[key])
                        }
                     }
                  })
               }
            }
         }
         this.DialogVisible = false
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      initActionBox() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = ''
         }
         this.sendDataList = []
         this.selectData = []
         this.selectIndex = 0,
            this.dataActionBox.actionType = 0
         this.dataActionBox.showStatus = false
         this.activeName = 'first'
      },
      openBox(cate, oldData = '') {
         this.initActionBox()
         this.dataActionBox.actionType = cate
         this.dataActionBox.showStatus = true

      },
      async sendDataAction(formName) {
         var flag = true
         this.$refs[formName].validate((valid) => {
            if (valid) {
               flag = true
            } else {
               flag = false
               return false;
            }
         });
         var sendData = [];
         var responseData
         if (this.activeName == 'first') {
            if (!flag) return
            if (this.sendDataInfo.jobid == "" || this.sendDataInfo.jobid == null) {
               return this.$message.error("请先提取单据")
            }
            sendData.push(this.sendDataInfo)
         } else {
            if (this.sendDataList.length == 0) {
               return this.$message.error("请先提取明细")
            }
            sendData = this.sendDataList
         }
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.gyxnCanceladd(sendData)
            if (responseData.status == 200) {
               this.initActionBox()
               this.$message({
                  message: '操作成功',
                  type: 'success'
               });
               this.$parent.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }
         }
      },

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() {
   }, //生命周期 - 创建之前
   beforeMount() {
   }, //生命周期 - 挂载之前
   beforeUpdate() {
   }, //生命周期 - 更新之前
   updated() {
   }, //生命周期 - 更新之后
   beforeDestroy() {
   }, //生命周期 - 销毁之前
   destroyed() {
   }, //生命周期 - 销毁完成
   activated() {
   }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   overflow-y: auto;
}

::v-deep .el-radio-button__orig-radio:disabled:checked+.el-radio-button__inner {
   color: #fff;
   background-color: #409eff;
   border-color: #409eff;
   box-shadow: -1px 0 0 0 #409eff;
}
</style>